import './style.scss';

function Carreer () {
    return(
        <section className='carreer-screen'>
            <div className='container'>
                <h1 className='title'> 
                    Csatlakozzon <span>hozzánk</span>, amennyiben
                </h1>
                <ul className='carreer-list'>
                    <li className='description'>
                        szeretne saját praxist indítani akár meglévő pácienskörével, akár pácienskör bővítés céljából, és új szintre lépni egy dinamikusan fejlődő egészségközpontban
                    </li>
                    <li className='description'>
                        szeretne rugalmas rendelési idővel dolgozni, amelyet saját igényeihez igazíthat
                    </li>
                    <li className='description'>
                        szeretne láthatóbbá válni szakmailag, és örülne a profi marketing- és online megjelenési támogatásnak
                    </li>
                    <li className='description'>
                        hosszú távú, biztonságos és kiszámítható partnerségben gondolkodik 
                    </li>
                </ul>  
                <div className='contact-box'>
                    <h2 className='contact-headline'> Vegye fel velünk a kapcsolatot a kizárólag üzleti partnereinknek fenntartott e-mail címen keresztül:</h2>
                    <a className='e-mail-button' href='mailto:vbek@gmail.com'>
                        vbek@gmail.com
                    </a>
                </div>
                
            </div>
        </section>
    )
};

export default Carreer;